import { useInterval } from 'usehooks-ts';

import { setTimeToNextSell } from '@/redux/reducers/appReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { useSelectorRef } from './selector-ref';

const useTimerToNextSell = (): void => {
  const dispatch = useAppDispatch();
  const timeToNextSellRef = useSelectorRef((state) => state.app.timeToNextSell);
  const hasTime = useAppSelector((state) => state.app.timeToNextSell > 0);

  useInterval(
    (): void => {
      const currentTime = timeToNextSellRef.current;

      if (currentTime > 0) {
        dispatch(setTimeToNextSell(currentTime - 1));
      }
    },
    hasTime ? 1000 : null,
  );
};

export { useTimerToNextSell };
